/* Amiraah — shared interactions v4 */
(function(){
  'use strict';

  function $(sel,ctx){ return (ctx||document).querySelector(sel); }
  function $$(sel,ctx){ return Array.prototype.slice.call((ctx||document).querySelectorAll(sel)); }
  function lockBody(){ document.body.style.overflow='hidden'; }
  function unlockBody(){ document.body.style.overflow=''; }

  /* ── Nav scroll state ── */
  var nav = $('#nav');
  if(nav){
    var onScroll = function(){ nav.classList.toggle('scrolled', window.scrollY > 4); };
    onScroll();
    window.addEventListener('scroll', onScroll, {passive:true});
  }

  /* ── Nav overlay ── */
  var navBurger  = $('#navBurger');
  var navOverlay = $('#navOverlay');
  var navClose   = $('#navClose');
  var backdrop   = $('#overlayBackdrop');

  function openNav(){
    if(!navOverlay) return;
    navOverlay.classList.add('open');
    navOverlay.setAttribute('aria-hidden','false');
    if(backdrop) backdrop.classList.add('show');
    if(navBurger) navBurger.setAttribute('aria-expanded','true');
    lockBody();
    if(navClose) navClose.focus();
  }
  function closeNav(){
    if(!navOverlay) return;
    navOverlay.classList.remove('open');
    navOverlay.setAttribute('aria-hidden','true');
    if(backdrop) backdrop.classList.remove('show');
    if(navBurger) navBurger.setAttribute('aria-expanded','false');
    unlockBody();
    if(navBurger) navBurger.focus();
  }
  if(navBurger) navBurger.addEventListener('click', openNav);
  if(navClose)  navClose.addEventListener('click', closeNav);
  if(backdrop)  backdrop.addEventListener('click', function(){ closeNav(); closeSearch(); });

  document.addEventListener('keydown', function(e){
    if(e.key !== 'Escape') return;
    if(navOverlay && navOverlay.classList.contains('open')) closeNav();
    if(searchOverlay && searchOverlay.classList.contains('open')) closeSearch();
  });

  /* ── Category accordion ── */
  $$('.nav-overlay__toggle').forEach(function(btn){
    btn.addEventListener('click', function(){
      var item = btn.closest('.nav-overlay__item');
      if(!item) return;
      var isOpen = item.classList.contains('expanded');
      $$('.nav-overlay__item.expanded').forEach(function(el){
        el.classList.remove('expanded');
        var t = el.querySelector('.nav-overlay__toggle');
        if(t) t.setAttribute('aria-expanded','false');
      });
      if(!isOpen){
        item.classList.add('expanded');
        btn.setAttribute('aria-expanded','true');
      }
    });
  });

  /* ── Search overlay ── */
  var searchBtn     = $('#searchBtn');
  var searchOverlay = $('#searchOverlay');
  var searchClose   = $('#searchClose');
  var searchInput   = $('#searchInput');

  function openSearch(){
    if(!searchOverlay) return;
    searchOverlay.classList.add('open');
    searchOverlay.setAttribute('aria-hidden','false');
    if(backdrop) backdrop.classList.add('show');
    lockBody();
    setTimeout(function(){ if(searchInput) searchInput.focus(); }, 60);
  }
  function closeSearch(){
    if(!searchOverlay) return;
    searchOverlay.classList.remove('open');
    searchOverlay.setAttribute('aria-hidden','true');
    if(backdrop && !(navOverlay && navOverlay.classList.contains('open'))){
      backdrop.classList.remove('show');
    }
    unlockBody();
    if(searchBtn) searchBtn.focus();
  }
  if(searchBtn)   searchBtn.addEventListener('click', openSearch);
  if(searchClose) searchClose.addEventListener('click', closeSearch);

  /* ── Category strip arrows ── */
  var catTrack = $('#catTrack');
  var catPrev  = $('#catPrev');
  var catNext  = $('#catNext');
  if(catTrack && catPrev && catNext){
    var tileW = function(){ var t = catTrack.querySelector('.cat-tile'); return t ? t.offsetWidth + 6 : 140; };
    catPrev.addEventListener('click', function(){ catTrack.scrollBy({left: -tileW()*3, behavior:'smooth'}); });
    catNext.addEventListener('click', function(){ catTrack.scrollBy({left:  tileW()*3, behavior:'smooth'}); });
  }

  /* ── Editorial slider dots ── */
  var editTrack = $('#editSliderTrack');
  var editDots  = $$('.slider-dot');
  if(editTrack && editDots.length){
    var updateDots = function(){
      var w = editTrack.querySelector('.editorial-card');
      if(!w) return;
      var cardW = w.offsetWidth + 2;
      var idx = Math.round(editTrack.scrollLeft / cardW);
      editDots.forEach(function(d,i){ d.classList.toggle('active', i === idx); });
    };
    editTrack.addEventListener('scroll', updateDots, {passive:true});
    editDots.forEach(function(dot){
      dot.addEventListener('click', function(){
        var idx = parseInt(dot.getAttribute('data-idx'),10);
        var w = editTrack.querySelector('.editorial-card');
        if(!w) return;
        editTrack.scrollTo({left: idx * (w.offsetWidth + 2), behavior:'smooth'});
      });
    });
  }

  /* ── Scroll reveal ── */
  var reveals = $$('.reveal');
  if('IntersectionObserver' in window && reveals.length){
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('in'); io.unobserve(e.target); } });
    }, {threshold:0.08, rootMargin:'0px 0px -4% 0px'});
    reveals.forEach(function(el){ io.observe(el); });
    var sweep = function(){
      var vh = window.innerHeight||800;
      $$('.reveal:not(.in)').forEach(function(el){
        var r = el.getBoundingClientRect();
        if(r.top < vh*0.98 && r.bottom > 0) el.classList.add('in');
      });
    };
    window.addEventListener('load', sweep);
    setTimeout(sweep,300); setTimeout(sweep,900);
  } else {
    reveals.forEach(function(el){ el.classList.add('in'); });
  }

  /* ── Designers: combined letter + category + text filter ── */
  var filterbar    = $('#filterbar');
  var catbar       = $('#catbar');
  var dsearch      = $('#designerSearch');
  var cards        = $$('.designer-card');
  var emptyMsg     = $('.designer-empty');

  if(cards.length){
    var activeLetter = '*';
    var activeCat    = '*';
    var searchTerm   = '';

    function applyFilter(){
      var shown = 0;
      cards.forEach(function(c){
        var letter = c.getAttribute('data-letter')||'';
        var cat    = c.getAttribute('data-cat')||'';
        var name   = (c.querySelector('.designer-card__name')||c).textContent.toLowerCase();
        var ok = (activeLetter==='*'||letter===activeLetter) &&
                 (activeCat==='*'||cat===activeCat) &&
                 (!searchTerm||name.indexOf(searchTerm)!==-1);
        c.classList.toggle('hide',!ok);
        if(ok) shown++;
      });
      if(emptyMsg) emptyMsg.style.display = shown ? 'none' : 'block';
    }
    if(filterbar){
      filterbar.addEventListener('click',function(e){
        var btn = e.target.closest('button'); if(!btn) return;
        activeLetter = btn.getAttribute('data-key');
        $$('button',filterbar).forEach(function(b){ b.setAttribute('aria-pressed',b===btn?'true':'false'); });
        applyFilter();
      });
    }
    if(catbar){
      catbar.addEventListener('click',function(e){
        var btn = e.target.closest('button'); if(!btn) return;
        activeCat = btn.getAttribute('data-cat');
        $$('button',catbar).forEach(function(b){ b.setAttribute('aria-pressed',b===btn?'true':'false'); });
        applyFilter();
      });
    }
    if(dsearch){
      dsearch.addEventListener('input',function(){
        searchTerm = dsearch.value.trim().toLowerCase();
        applyFilter();
      });
    }
  }

  /* ── Newsletter ── */
  var newsletterForm = $('#newsletterForm');
  if(newsletterForm){
    newsletterForm.addEventListener('submit',function(e){
      e.preventDefault();
      var inp = $('#newsletterEmail');
      if(!inp||!inp.value.trim()||inp.value.indexOf('@')===-1) return;
      newsletterForm.innerHTML = '<p style="font-family:var(--serif);font-size:17px;font-weight:300;color:var(--ink)">Thank you — we\'ll be in touch.</p>';
    });
  }

  /* ── Gallery lightbox ── */
  var gallery = $('.gallery');
  if(gallery){
    var lb = $('#lightbox');
    var lbImg = lb ? lb.querySelector('img') : null;
    gallery.addEventListener('click',function(e){
      var fig = e.target.closest('figure'); if(!fig||!lb) return;
      var img = fig.querySelector('img');
      if(lbImg){ lbImg.src = img.getAttribute('data-full')||img.src; lbImg.alt = img.alt||''; }
      lb.classList.add('open'); lockBody();
    });
    if(lb){
      var closeLb = function(){ lb.classList.remove('open'); unlockBody(); };
      lb.addEventListener('click',closeLb);
      document.addEventListener('keydown',function(e){ if(e.key==='Escape') closeLb(); });
    }
  }

})();

/* ── Hero slideshow (auto-rotating crossfade) ── */
(function(){
  'use strict';
  var hero = document.getElementById('heroSlider');
  if(!hero) return;
  var slides = Array.prototype.slice.call(hero.querySelectorAll('.hero-slider__slide'));
  var dots   = Array.prototype.slice.call(hero.querySelectorAll('.hero-slider__dot'));
  if(slides.length < 2) return;
  var interval = parseInt(hero.getAttribute('data-interval'), 10) || 6000;
  var idx = 0, timer = null;

  function show(n){
    idx = (n + slides.length) % slides.length;
    slides.forEach(function(s,i){ s.classList.toggle('is-active', i === idx); });
    dots.forEach(function(d,i){ d.classList.toggle('is-active', i === idx); });
  }
  function next(){ show(idx + 1); }
  function start(){ stop(); timer = setInterval(next, interval); }
  function stop(){ if(timer){ clearInterval(timer); timer = null; } }

  dots.forEach(function(d){
    d.addEventListener('click', function(){
      show(parseInt(d.getAttribute('data-idx'), 10) || 0);
      start();
    });
  });
  hero.addEventListener('mouseenter', stop);
  hero.addEventListener('mouseleave', start);
  document.addEventListener('visibilitychange', function(){ document.hidden ? stop() : start(); });

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if(!reduce) start();
})();

/* ── Scroll reveal for sections ── */
(function(){
  'use strict';
  var els = Array.prototype.slice.call(document.querySelectorAll('.sec-reveal'));
  if(!els.length) return;
  if(!('IntersectionObserver' in window)){ els.forEach(function(e){ e.classList.add('in-view'); }); return; }
  var io = new IntersectionObserver(function(entries){
    entries.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('in-view'); io.unobserve(e.target); } });
  }, { threshold: 0.08, rootMargin: '0px 0px -5% 0px' });
  els.forEach(function(e){ io.observe(e); });
})();

/* ── Designers page: pre-filter from ?q= (deep link from search) ── */
(function(){
  'use strict';
  var input = document.getElementById('designerSearch');
  if(!input) return;
  try {
    var q = new URLSearchParams(window.location.search).get('q');
    if(q){ input.value = q; input.dispatchEvent(new Event('input', {bubbles:true})); input.focus(); }
  } catch(e){}
})();
